import React, { useState } from "react"
import PropTypes from 'prop-types'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'
import Button from 'react-bootstrap/Button'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import ContactIcon from "./ContactIcon"

import { DarkBackground, IsEmptyString } from "./GeneralFunctions"
import { ThemeBackgroundColor, ThemeCallButtonLight } from "./Themes"
import { Translate } from "./Translator"

//import ImageMakeCall from './ImageMakeCall'
//import ImageScreenpop from './ImageScreenpop'

import ActionCallSmallLightBgPng from '../Assets/action_call_small_lightbg.png'
import ActionCallSmallDarkBgPng from '../Assets/action_call_small_darkbg.png'
import ActionMultiplePng from '../Assets/action_multiple.png'

import ActionCallXelionLightPng from '../Assets/xelion_call_light.png'
import ActionCallXelionDarkPng from '../Assets/xelion_call_dark.png'

const SearchResult = (props) => {

    const BackgroundColor = ThemeBackgroundColor()

    const [mMouseOver, SetMouseOver] = useState(false)
    const [mRepaint, SetRepaint] = useState(false)

    const PerformScreenpop = (aScreenpopUrl) => {
        window.open(aScreenpopUrl)
        SetRepaint(!mRepaint)
    }

    const Name = ((props.Name === null) || (props.Name === undefined)) ? "" : props.Name    
    let Organization = ((props.Organization === null) || (props.Organization === undefined)) ? "" : props.Organization
    Organization = Name !== Organization ? Organization : ""
    const Application = ((props.Application === null) || (props.Application === undefined)) ? "" : props.Application
    const CallButtonLight = ThemeCallButtonLight()

    return (
        <table className={props.OddRow ? "searchresult searchresultoddrow" : "searchresult"} style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }} onMouseEnter={e => SetMouseOver(true)} onMouseLeave={e => SetMouseOver(false)}>
        <tbody>
            <tr>
                <td width="4"/>
                <td width="40" className="padded3">{<ContactIcon Application={Application} Name={Name} Number={props.Number}/>}</td>
                <td width="4"/>
                <td width="*" className="padded3" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} align="left">
                    {(Name !== "") && (Organization !== "") ? Name + " | " + Organization : (Name !== "") || (Organization !== "") ? Name + Organization : "Unknown contact"}<br/>
                    {props.Number}
                </td>
                <td width="10"/>
                {mMouseOver ? 
                    <td width="120" align="right">
                        <Popup trigger={<span className="up2px"><img alt="" src={ActionMultiplePng}  className="action"/></span>} arrow={false} closeOnDocumentClick={true} keepTooltipInside={true}>
                            <div onClick={() => props.MakeCall(props.Number, props.Name, props.Organization, props.Application, props.ScriptName, props.ScreenpopUrl)} className="popupmenuitem"><span className="popupmenuitemtext">{Translate("Call back")}</span></div>    
                            <div className="popupmenuitem"><CopyToClipboard text={props.Number}><span className="popupmenuitemtext">{Translate("Copy number")}</span></CopyToClipboard></div>
                                                        
                            {props.Scripts === null ? <span/> : props.Scripts.map((script,index) => (                        
                                script.ScreenpopUrl ? <div onClick={() => PerformScreenpop(script.ScreenpopUrl)} className="popupmenuitem" key={index}><span className="popupmenuitemtext">{script.Name}</span></div> : <span/> 
                            ))} 
                            
                            {props.OnRemoveFromSearchHistory == null ? <></> :
                                <div onClick={() => props.OnRemoveFromSearchHistory()} className="popupmenuitem"><span className="popupmenuitemtext">{Translate("Remove from view")}</span></div>
                            }
                        </Popup>

                        &nbsp;&nbsp;

                        {props.Brand === "xelion" ?
                            <span className="up2px"><Button variant="light" className="callbuttonxelion action" style={{ }} onClick={() => props.OnMakeCall(props.Number, props.Name, props.Application, props.Scripts)}><img alt="" src={CallButtonLight ? ActionCallXelionLightPng : ActionCallXelionDarkPng} style={{ marginTop: "-4px", marginLeft: "-6px" }}/></Button></span> :
                            <span className="up2px"><Button variant="light" className="callbutton action" onClick={() => props.OnMakeCall(props.Number, props.Name, props.Application, props.Scripts)}><img alt="" src={CallButtonLight ? ActionCallSmallLightBgPng : ActionCallSmallDarkBgPng} className="up5px"/>&nbsp; <span className="up3px">{Translate("Call")}</span></Button></span>
                        }
                    </td> : 
                    <></>}
            </tr>
        </tbody>
        </table>
    )
}

SearchResult.propTypes = {
    OddRow: PropTypes.bool,
    Number: PropTypes.string,
    Name: PropTypes.string,
    Organization: PropTypes.string,
    Application: PropTypes.string,
    Scripts: PropTypes.array,
    TenantGuid: PropTypes.string,
    Brand: PropTypes.string,
    OnMakeCall: PropTypes.func,
    OnRemoveFromSearchHistory: PropTypes.func
  }

export default SearchResult;